<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="query.zoneId"
                style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择片区"
                allow-clear
                tree-default-expand-all
              ></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编码">
              <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入连接点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编号">
              <a-input v-model="query.appearanceNo" placeholder="请输入用户编号" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.username" placeholder="请输入用户名称,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="电话号码">
              <a-input v-model="query.telephone" placeholder="请输入电话号码,支持模糊查询" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" default-value v-model="query.status" allow-clear>
                <a-select-option :key="0">在线</a-select-option>
                <a-select-option :key="1">库存</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle()" v-action:export>导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :scroll="{ x: 2100 }"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
        <a-divider type="vertical" />
        <a @click="showUseWater(record.appearanceNo)">统计用水量</a>
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="installDate" slot-scope="text">
        <span v-if="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
        <span v-else>{{ text }}</span>
      </span>
      <template slot="waterTypeAction" slot-scope="text">
        <span v-if="text == 0">居民用水</span>
        <span v-if="text == 1">非居民用水</span>
        <span v-if="text == 2">特种用水</span>
      </template>
      <template slot="statusAction" slot-scope="text">
        <a-tag v-if="text == 0" color="rgb(50, 205, 50)">在线</a-tag>
        <a-tag v-if="text == 1" color="#1890ff">库存</a-tag>
      </template>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-radio-group
            @change="onChangeRadio"
            v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }] }]"
          >
            <a-radio :value="0">在线</a-radio>
            <a-radio :value="1">库存</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码" v-show="onChange">
          <a-input
            placeholder="分类编码"
            :disabled="disabled"
            v-decorator="['classNo', { rules: [{ required: true, message: '请输入分类编码' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="表数量" v-show="onChange">
          <a-input
            placeholder="表数量"
            v-decorator="['meterNum', { rules: [{ required: true, message: '请输入表数量' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户编号" v-show="onChange">
          <a-input
            placeholder="用户编号"
            :disabled="disabled"
            v-decorator="['appearanceNo', { rules: [{ required: true, message: '请输入用户编号' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="型号">
          <a-input placeholder="型号" v-decorator="['model', { rules: [{ required: true, message: '请输入型号' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="厂家">
          <a-input placeholder="厂家" v-decorator="['firm', { rules: [{ required: true, message: '请输入厂家' }] }]" />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="片区选择"
        >
          <a-tree-select
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]"
            style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择片区"
            allow-clear
            tree-default-expand-all
          ></a-tree-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用户名称"
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="用户名称"
            v-decorator="['userNikeName', { rules: [{ required: true, message: '用户名称' }] }]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="地址"
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="地址"
            v-decorator="['address', { rules: [{ required: true, message: '请输入地址' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="电话"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="电话"
            v-decorator="['telephone', { rules: [{ required: true, message: '请输入电话' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="安装日期"
        >
          <a-date-picker
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD 00:00:00"
            placeholder="安装日期"
            v-decorator="['installDate', { rules: [{ required: true, message: '请输入安装日期' }] }]"
          />
        </a-form-item>

        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="表身号"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="表身号"
            v-decorator="['meterModel', { rules: [{ required: true, message: '请输入表身号' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="物探点号"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="物探点号"
            v-decorator="['geophysicalPointNumber', { rules: [{ required: true, message: '请输入物探点号' }] }]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="坐标点X"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="坐标点X"
            v-decorator="[
              'coordinatePointX',
              { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确坐标点X' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="坐标点Y"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="坐标点Y"
            v-decorator="[
              'coordinatePointY',
              { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确坐标点Y' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="地面高程"
        >
          <a-input
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            placeholder="地面高程"
            v-decorator="[
              'groundElevation',
              { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入正确地面高程' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          v-if="addOrUpdateForm.getFieldValue('status') === 0"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用水类型"
        >
          <a-select
            v-if="addOrUpdateForm.getFieldValue('status') === 0"
            v-decorator="['waterType', { rules: [{ required: true, message: '请选择' }] }]"
            style="width: 120px"
          >
            <a-select-option :value="0">居民用水</a-select-option>
            <a-select-option :value="1">非居民用水</a-select-option>
            <a-select-option :value="2">特种用水</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <show-line ref="ShowLine"></show-line>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import { getPipeLineMaterialOptions, getPipeDiameterSizeOptions } from '@/api/manage'
import ShowLine from './ShowLine'
import pick from 'lodash.pick'
import moment from 'moment'
const columns = [
  {
    title: '分类编码',
    dataIndex: 'classNo',
  },
  {
    title: '片区',
    dataIndex: 'zoneName',
  },
  {
    title: '用户编号',
    dataIndex: 'appearanceNo',
  },
  {
    title: '用户名称',
    dataIndex: 'userNikeName',
  },
  {
    title: '地址',
    dataIndex: 'address',
    ellipsis: true,
  },
  {
    title: '电话',
    dataIndex: 'telephone',
  },
  {
    title: '安装日期',
    dataIndex: 'installDate',
    scopedSlots: { customRender: 'installDate' },
  },
  {
    title: '型号',
    dataIndex: 'model',
  },
  // {
  //   title: '表数量',
  //   dataIndex: 'meterNum'
  // },
  {
    title: '厂家',
    dataIndex: 'firm',
  },
  {
    title: '表身号',
    dataIndex: 'meterModel',
  },
  {
    title: '物探点',
    dataIndex: 'geophysicalPointNumber',
  },
  {
    title: '用水类型',
    dataIndex: 'waterType',
    scopedSlots: { customRender: 'waterTypeAction' },
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' },
  },

  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 150,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'UserRemoteWaterList',
  components: {
    ShowLine,
  },
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/yc_user_remote_water_meters/page',
      deleteUrl: '/pipe-network/yc_user_remote_water_meters',
      addOrUpdateUrl: '/pipe-network/yc_user_remote_water_meters',
      queryOneUrl: '/pipe-network/yc_user_remote_water_meters',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/yc_user_remote_water_meters/export',
      exportFileName: '贸易结算表.xlsx',
      mapVisible: false,
      disabled: false,
      onChange:true,
      geoJson: '',
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      zoneTreeData: [], // 片区选项
      query: {
        geophysicalPointNumber: '',
        telephone: '',
        appearanceNo: '',
        username: '',
        connection: '',
        zoneId: '',
        status: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    this.getAllTenant()
    this.getZoneData()
    this.resetList()
  },
  methods: {
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    moment,
    onChangeRadio(e) {
      if(e == 0){
        this.onChange = true
      }else{
           this.onChange = false
      }
      let val = e.target.value
      console.log(val)
    },
    addOrUpdateHandle(id) {
      if (id !== undefined) {
        this.disabled = true
        console.log(id, 'hii')
      } else {
        this.disabled = false
        console.log(id, 'hiio')
      }
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue({ status: data.status })
            this.$nextTick(() => {
              
              setTimeout(() => {
                this.addOrUpdateForm.setFieldsValue(
                  pick(
                    data,
                    'meterNum',
                    'classNo',
                    'zoneId',
                    'model',
                    'firm',
                    'appearanceNo',
                    'userNikeName',
                    'address',
                    'telephone',
                    'installDate',
                    'meterModel',
                    'geophysicalPointNumber',
                    'coordinatePointX',
                    'coordinatePointY',
                    'groundElevation',
                    'waterType'
                  )
                )
              })
            })
          })
          .catch(() => {})
      } else {
        this.addOrUpdateForm.setFieldsValue({ status: 0 })
      }
    },
    showUseWater(appearanceNo) {
      this.$refs.ShowLine.edit(appearanceNo)
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    detailInfo(record) {
      this.detailForm = { ...record }
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel() {},
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
  /deep/ .ant-form-item {
    margin-bottom: 16px;
  }
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
